import styled from 'styled-components';
import { ThemeColours } from '../../styles/ThemeColours';
import { FONT_STACK } from '../../styles/constants';

export const ErrorHarness = styled.div`
  width: 100%;
`;

export const ErrorMessage = styled.div`
  ${FONT_STACK}
  color: ${ThemeColours.negative};
  font-size: 16px;
  line-height: 24px;
  margin: 6px 0;

  &:before {
    background-image: url('https://healthengine.imgix.net/public/images/he-booking-process-icons-64-nv2_20180420082300.svg?auto=compress&or=0');
    background-position: center -25px;
    background-repeat: no-repeat;
    content: '';
    display: inline-block;
    height: 17px;
    margin: -2px 5px 0 0;
    vertical-align: middle;
    width: 17px;
  }
`;
